/* eslint-disable no-restricted-globals */
// @ts-nocheck
import React, {useState, useMemo, useEffect, useRef} from "react";
import {Controller, useForm} from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {useClickOutside, useCountdown} from "hooks";
import { CloseButtonModal } from "components/CloseButton";
import { useStores } from "hooks/useStores";
import { INVALIDATION_TIP } from "../../const/validation";
import { IMaskInput } from "react-imask";
import { ButtonCustom } from "../ButtonCustom";
import { FormLabel } from "../FormLabel";
import { TextInput } from "../TextInput";

import styles from "./styles/lkChangePhone.module.scss";

const handleChangeMaxLength = (e, maxLength) => {
  e.target.value = e.target.value.slice(0, maxLength);
};

const firstStepSchema = yup.object().shape({
  new_phone: yup
    .string().nullable().transform((v, o) => (o === '' ? null : v)).matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE)
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE),
});

const secondStepSchema = yup.object().shape({
  new_phone: yup
    .string().nullable().transform((v, o) => (o === '' ? null : v))
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE),
  code: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{4}/, INVALIDATION_TIP.MIN_CODE_LENGTH),
});

const FAST_REG_STEPS = {
  GET_CODE: 1,
  CHECK_CODE: 2
};

export default function LkChangePhone(props) {
  const [step, setStep] = useState(1);
  const [timerSeconds, setTimerSeconds] = useState(null)

  const [changePhone, setPhoneChanged] = useState(true);
  const [confirmCode, setConfirmCode] = useState(false);

  const [response, setResponse] = useState({});

  const { api, userStore } = useStores();
  const { minutes, seconds, isOver, resetTimer } = useCountdown(timerSeconds);

  const formSchema = useMemo(
    () => (step === 1 ? firstStepSchema : secondStepSchema),
    [step],
  );

  const containerRef = useClickOutside(() => {
    closeAddPhoneModal();
  })

  const {
    handleSubmit,
    formState: { errors, isValid },
    reset,
    control,
    setError,
    clearErrors,
    trigger,
    watch
  } = useForm({
    mode: "all",
    resolver: yupResolver(formSchema),
  });

  const allFildes = watch();

  const getCode = (data) => {
    const reqObj = { ...data, new_phone: `+${data.new_phone}` };

    reset({ code: '' }, { keepValues: true });
    api.user.postAddPhoneProfile(reqObj).then((response) => {
      setConfirmCode(true);
      console.log(response, 'response')
      handleGetCode();
      setTimerSeconds(response.expires_in);
      resetTimer(response.expires_in);
    }).catch((error) => {
      setError('new_phone', {
        message: error.response.data.new_phone[0],
      });
    });
  }

  const onSubmit = (data) => {
    const reqObj = { ...data, new_phone: `+${data.new_phone}` };

    switch (step) {
      case FAST_REG_STEPS.GET_CODE:
        getCode(data)
        break;

      case FAST_REG_STEPS.CHECK_CODE:
        api.user.postConfirmSmsForPhoneProfile(reqObj).then((response) => {
          setResponse(response)
          userStore.getUser()
          setPhoneChanged(false)
          goToLk();
        }).catch((error) => {
          setError('code', {
            message: error.response.data.code,
          });
        });
        break;

      default:
        break;
    }
  };

  const handleGetCode = () => {
    setStep(2);
    clearErrors();
  };

  const closeAddPhoneModal = () => {
    document.querySelector("#changePhonePopup").style.display = "none";
    setConfirmCode(false);
  };

  const goToLk = () => {
    closeAddPhoneModal();
    setPhoneChanged(false);
    setStep(1);
  };

  const resendCode = () => {
    const reqestWatch = { new_phone: allFildes.new_phone }
    getCode(reqestWatch)
  };

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      mounted.current = false;
    } else {
      // do componentDidUpdate logic
      if (response.code_valid === true) {
        setPhoneChanged(true);
      }
    }
  }, [response]);

  return (
    <div className={styles.change_phone} id='changePhonePopup'>
      <div className={styles.container} ref={containerRef}>
        <CloseButtonModal handleClose={ closeAddPhoneModal }/>
        <div className={styles.container_main} id='containerMain'>
          <h1 className={styles.change_phone_title}>Изменение номера телефона</h1>
          <form
            className={styles.form}
            onSubmit={handleSubmit(onSubmit)}>
            {step === 1 &&
              <>
                <div className={styles.form_controllers}>
                  <div className={styles.form_controllers_controller}>
                    <FormLabel className={styles.forn_controllers_controller__label} text="Контактный номер телефона"/>
                    <Controller
                      render={({field: {onChange, value}}) => (
                        <IMaskInput
                          className={styles.form_controllers_controller__input}
                          mask={'+{7} (000) 000-00-00'}
                          unmask={true}
                          value={value}
                          onAccept={(val) => onChange(val)}
                          disabled={step !== 1}
                          onBlur={() => trigger()}
                        />
                      )}
                      id="new_phone"
                      name="new_phone"
                      type="tel"
                      control={control}
                    />
                  </div>
                  {errors.new_phone && (
                    <span className={styles.form_controllers_controller_bottom__error}>{errors.new_phone?.message}</span>
                  )}
                </div>
                <ButtonCustom
                  className={styles.fast_registration__sms_button}
                  text="Получить код из SMS"
                  type="submit"
                  disabled={!isValid}
                />
              </>
            }
            {step === 2 &&
              <>
                <div className={styles.form_controllers}>
                  <div className={styles.form_controllers_controller}>
                    <FormLabel className={styles.form_controllers_controller__label} text="Контактный номер телефона"/>
                    <Controller
                      render={({field: {onChange, value}}) => (
                        <IMaskInput
                          className={styles.form_controllers_controller__input}
                          mask={'+{7} (000) 000-00-00'}
                          unmask={true}
                          value={value}
                          onAccept={(val) => onChange(val)}
                          disabled={true}
                          onBlur={() => trigger()}
                        />
                      )}
                      id="new_phone"
                      name="new_phone"
                      type="tel"
                      control={control}
                    />
                  </div>
                  <div className={styles.form_controllers_controller_sms}>
                    <FormLabel
                      className={styles.form_controllers_controller_sms__label}
                      text="Код из SMS"
                      isRequired
                    />
                    <Controller
                      render={({field: {onChange, value}}) => (
                        <TextInput
                          className={styles.form_controllers_controller_sms__input}
                          type="number"
                          controls={false}
                          onChange={(event) => {
                            handleChangeMaxLength(event, 4)
                            onChange(event)
                          }}
                          step={1}
                        />
                      )}
                      name="code"
                      control={control}
                    />
                    <div className={styles.form_controllers_controller_bottom}>
                      <div className={styles.form_controllers_controller_bottom__group}>
                        { !isOver && (
                            <span className={styles.form_controllers_controller_bottom__action_time}>
                              {`Время действия ${minutes}:${seconds}`}
                            </span>)
                        }
                      </div>
                    </div>
                  </div>
                  {errors.code && (
                    <span className={styles.form_controllers_controller_bottom__error}>
                          {errors.code?.message}
                        </span>
                  )}
                  { isOver && (
                    <button
                      type="button"
                      className={styles.form_controllers_controller_bottom__get_new_code}
                      onClick={resendCode}
                    >
                      Получить новый код
                    </button>
                  )}
                </div>
                <ButtonCustom
                  className={styles.fast_registration__sms_button}
                  text="Сохранить"
                  type="submit"
                  disabled={!isValid}
                />
              </>
            }
          </form>
        </div>
      </div>
    </div>
  );
}
